export const getPriceDiscount = ({
  first_price,
  second_price,
}: {
  first_price: number;
  second_price: number;
}): number => {
  const percentage = ((first_price - second_price) / first_price) * 100;
  return Math.abs(Math.round(percentage));
};

export const getPrimaryPrice = ({
  yearlyPrices,
  monthlyPrices,
  weeklyPrices,
}: {
  yearlyPrices: PaddlePrice[];
  monthlyPrices: PaddlePrice[];
  weeklyPrices: PaddlePrice[];
}): PaddlePrice | undefined =>
  yearlyPrices[0] ?? monthlyPrices[0] ?? weeklyPrices[0];
